import { render, staticRenderFns } from "./changeStudentDialog.vue?vue&type=template&id=65843c68"
import script from "./changeStudentDialog.vue?vue&type=script&lang=js"
export * from "./changeStudentDialog.vue?vue&type=script&lang=js"
import style0 from "./changeStudentDialog.vue?vue&type=style&index=0&id=65843c68&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports